import { API } from '../config'
import { AxiosResponse } from 'axios'
import { CoverageProcessParams } from 'src/domain/coverage-process'
import { CoverageProcessDto } from 'src/dto/coverage-process.dto'

const BASE_URL = 'entity/ProcessoCobertura'

export class CoverageProcessService {
  public async getCoverageProcessList(farmId: string): Promise<AxiosResponse<CoverageProcessDto[]>> {
    return await API.get(`${BASE_URL}/${farmId}`)
  }

  public async createCoverageProcess(
    farmId: string,
    coverageProcessDto: CoverageProcessParams
  ): Promise<AxiosResponse<CoverageProcessDto>> {
    return await API.put(`${BASE_URL}/${farmId}`, coverageProcessDto)
  }

  public async updateCoverageProcess(
    farmId: string,
    coverageProcessDto: CoverageProcessParams
  ): Promise<AxiosResponse<CoverageProcessDto>> {
    return await API.put(`${BASE_URL}/${farmId}`, coverageProcessDto)
  }
}
